<template>
  <v-layout>
    <v-container  grid-list-lg>
      <v-layout row wrap class="flex_box feature_products"> 
        <v-flex xs12>
          <!-- <h5 class="text-xs-center">Ürünler</h5> -->
          <h2 class="text-xs-center feature_products_title">kampanjoinut <span>  Tuotteet</span></h2>
          <div class="title_border"></div>
        </v-flex>

    <v-flex xs12 sm3 md3 lg3 xl2   grow class="flex_item" v-for="(product,index) in products" :key="index">
            <v-hover>
          <v-card   max-width="600" 
          class="pa-1 mx-auto" height="Auto"  
          slot-scope="{ hover }"
      :class="`elevation-${hover ? 12 : 2}`">  
      <div class="text-xs-center orange  white--text"> - % {{product.discountpercent}} Alennus </div>
      <v-row>
            <v-img  :src="product.image" aspect-ratio="1" class="ma-4"  contain></v-img>
      </v-row>   
            <v-card-title style="height:165px">
              <div style="width:100%;"  class="text-xs-center">
                    <h4 class="text-xs-center red--text text--darken-3">{{product.code}}</h4>
                <h4 class=" text-xs-center grey--text text--darken-3">{{product.item_name}}</h4>
    <h4 class="green white--text text-xs-center">On Stock</h4>
                <h4 class=" text-xs-center grey--text text--darken-3">Kol ({{product.packageamount}} x ST)</h4>           
                <h5 class="black--text text--darken-1 text-line-through">{{product.price}} € / {{product.package_price}} €</h5>   
                    <h4 class="black--text text--darken-1 ">{{product.discounted_price}} € / {{product.discounted_package_price}} €</h4>           
                 <!-- <div class="row layout justify-center text-xs-center"  >    
                <h4 class="grey--text text--darken-3 ">{{product.discounted_price}} € / </h4>      
                <h4 class="red--text text--darken-3 text-uppercase"> {{ product.discounted_package_price}} €</h4>    

                 </div>                                      -->
              </div>
              </v-card-title> 
        <v-row >
            <v-card class="my-3" >   
        <v-flex pa-0>
       <v-layout   justify-center row align-center>
                  <v-btn flat  small pa-5 color="primary" @click="decreasecount(product)">
      <v-icon dark>remove</v-icon>
    </v-btn>            
                    {{product.prcount}}         
            <v-btn  flat small pa-5 color="primary"  @click="increasecount(product)">
      <v-icon dark>add</v-icon>
    </v-btn>
      </v-layout >
  </v-flex>                    
            </v-card>
        </v-row>
        <v-row >
           <v-card-actions > 
               <v-flex   pa-0>
             <v-layout   justify-center row align-center>
                <v-btn small flat    color="red"   :to="'/product/' + product.id">Yksityiskohta</v-btn>
            <v-btn  icon flat color="success"  @click="addToCart(product)">
              <v-icon>shopping_cart</v-icon>
            </v-btn>   
            </v-layout >
              </v-flex>   
              </v-card-actions>
        </v-row>
               </v-card>
                   </v-hover>
        </v-flex>  

        <!-- <v-flex xs12 sm3 md3 lg3 xl2  class="flex_item" v-for="(product,index) in products" :key="index">
          <v-card class="overlay_container flex_wrap  pa-2">
            <v-img :src="product.image" contain></v-img>
            <div style="width:100%;" class="flex_bottom text-xs-center pb-2">
              <h3 class="headline text-xs-center grey--text text--darken-3">{{product.item_name}}</h3>
              <h4 class="grey--text text--darken-3">{{currency}}{{product.price}}</h4>                                           
            </div>
            
            <v-card class="overlay">                       
                <h2 style="vertical-align:middle;">{{product.item_name}}</h2>                        
                <v-list class="details">
                <v-list-tile-action>
                    <v-btn style="width:100%"  :to="'/product/' + product.id">Yksityiskohta</v-btn>
                </v-list-tile-action>
                <v-list-tile-action>
                    <v-btn style="width:100%" class="main_color white--text" @click="addToCart(product)">Lisää Ostoskoriin</v-btn>
                </v-list-tile-action>
                </v-list>
            </v-card>   
          </v-card>                                           
        </v-flex>         -->
      </v-layout>
    </v-container>
  </v-layout>
</template>
   
<script>
  import firebase from "firebase";
    import axios from "axios";
  import moment from 'moment' 
import campaignsVue from '../../admin/stock/campaigns.vue';
  export default {
    data(){
      return{
        currency:null,
        products:[],
        cart:this.$store.getters.cart 
      }
    },
    methods: {
      productInCart(product) {
        const cartItems = this.cart
        for (let i = 0; i < cartItems.length; i++) {
          if (cartItems[i].product.id === product.id) {
            return i       
          }
        }
        return null
      },
      increasecount(product)
      {
        product.prcount++;

      } ,  
         decreasecount(product)
      {
        if(product.prcount>1)
        product.prcount--;

      } ,       
      addToCart(product, quantity){

// let productx=product;

//         productx.price=product.discounted_price;
//         productx.package_price=product.discounted_package_price;

        const index = this.productInCart(product)
        const productQuantity = (!quantity || quantity < 1) ? 1 : parseInt(quantity)
        if (index === null) {
          var items = {
              product: product,
              quantity: product.prcount
          }
          //this.$store.commit('catalog/updateCart', items)
          this.$store.commit('updateCart', items)
        }else {
          if(!quantity){
              // If item is already into the cart then add++ quantity       
               var itemsx = {
              index: index,
              quantity: product.prcount
          }
     
          this.$store.commit('updateQuantity', itemsx)

              
          }else{
              // When quantity updated manually
          }
        }          
      },
      removeCart(index){
        this.$store.commit('removeCart', index)     
      }, 
    },
    computed:{
      counter(){
        return this.$store.getters.counter 
      },
    },   
    created(){
      var db = firebase.firestore();
      // Current Currency   
      db.collection("settings").doc('config').onSnapshot(doc =>{
        this.currency = doc.data().currency
      })
      let camplist=[];
       let newRef = db.collection('products_short2') 
 let ref = db.collection('campaigns') 
        ref.onSnapshot(snapshot => {
             snapshot.docChanges().forEach(change => {
            if(change.type == 'added'){
                let doc = change.doc
                let xarr=doc.data();
                xarr.id=doc.id;
camplist.push(xarr);

          console.log("camplist: " + doc.id)
            }
        })
        })

        //  if(doc.data().order_status=='Pending')

axios.post('https://europe-west1-elatukku-23ef3.cloudfunctions.net/getcampproducts')
 .then ( res=> {
   Array.from(res.data.result).forEach(element => {
     
     let newprice=0;
     let newpackprice=0;
     let campidx= "0";
     newRef.doc(element.product_id).get().then(asd=>{
       campidx= asd.data().campaign_id;
    

var selectedcampaign=camplist.find(cmp=>cmp.id==campidx)

console.log("selectedcamp:"+selectedcampaign)

let amountc=1;
let pckid="";
    var asd=element.packages.find(pck=>pck.isdefault==true);
       if(asd!=null)
       {
       amountc=asd.amount;
       pckid=asd.package_id
       }
       else
        amountc=1;

       let imagec="";

                    var asdx=element.images.find(img=>img.variant=="medium");
                    if(asdx!=null)
                    imagec=asdx.url;
                    else
                       imagec=element.images[element.images.length-1].url 
                       
                       if(selectedcampaign.campaign_Ratio!=null){
                         newprice= (Math.round(element.price*(1-selectedcampaign.campaign_Ratio/100) * 100) / 100).toFixed(2);
                         newpackprice=(Math.round(newprice*amountc * 100) / 100).toFixed(2);
                         }                         
                         else{
                           newprice=element.price-selectedcampaign.campaign_Euro
                           newpackprice=newprice.amountc
                           }


       this.products.push({
              id:element.product_id,
              product_id:element.product_id,
              image:imagec,       
              item_name:element.name,
               code:element.code,
         //     vat:element.vat, 
              vatpercent:element.vatpercent,
              packageamount:amountc,
              package_id:pckid,
              iscampaign:element.iscampaign,
              name:element.name,
               discounted_price:newprice,
               price:(Math.round(element.price * 100) / 100).toFixed(2),
              category_name:null,
                  package_price:(Math.round(amountc*element.price * 100) / 100).toFixed(2),
                  discounted_package_price:newpackprice,
                  prcount:1,
                  discountpercent:selectedcampaign.campaign_Ratio,
                  discount:selectedcampaign.campaign_Euro
      //        timestamp:moment(doc.data().modifytime).format('ll')
       });
            })     
             })
    })

      // Show All Items
      let cref = db.collection('products_short2').orderBy('timestamp', 'desc').where("isnew", "==", true)

      cref.onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if(change.type == 'added'){
            let doc = change.doc
            this.products.push({
              id:doc.id,
              item_name:doc.data().name,
        //      image:doc.data().image,
            //  category_name:doc.data().item_category.category_name,
              price:doc.data().taxprice,
              quantity:doc.data().code,
           //   timestamp:moment(doc.data().timestamp).fromNow('lll')
            })
          }
        })
      })
    } 
  }
</script>

<style>
  .v-list{
    padding:0!important;
   } 
  .flex_box{
    display:flex;
  }
  .flex_item{
    flex:1;
    display:flex;
    flex-wrap:wrap;
    flex-grow: 1;
  }
  .flex_wrap{
    text-align:center;
    flex:1;
    display:flex;
    flex-wrap:wrap;
  }
  .flex_wrap>*{
    flex:1 1 100%;
  }
  .flex_bottom{
    align-self:flex-end;
  }
  .flex_box .v-card{
    width:100%;
  }
  .flex_item .headline{
    width:100%;
    margin-bottom:15px;
  }
  .flex_box .v-card__text {
    padding: 0px;
  }
  .flex_box .v-card__title {
    padding:10px  0;
  }
   .flex_box .v-card__title h5 {
    text-decoration: line-through;
      font-size: 13px!important;
      font-family: 'Lobster Two', cursive;
    color: #8b1b1b;
  }
  .feature_products h5{
    font-size: 24px!important;
    letter-spacing: 0.4px!important;
    line-height: 15px;
    font-family: 'Yesteryear', cursive;
    text-transform: capitalize;
    color:#3E3939;
  }
  .row_layout{
  display: flex;
    align-items: center;
    justify-content: center;
    height: 100vh;
  }
  .feature_products_title{
    font-weight: 600;
    font-size: 35px;
    color: #3E3939;
    margin:0px 0px 15px;
    font-family: 'Lobster Two', cursive;
    text-transform: capitalize;
  }
  .feature_products_title  span{
    color: #345B2C;
  }
  .overlay{
    position:absolute !important;
    top:0;
    left:0;
    width:100%;
    height:100%;
    opacity:0;
    text-align:center;
    background: rgb(0,0,0,.4)!important;
    -webkit-transition: all 0.5s;
    -moz-transition: all 0.5s;
    -ms-transition: all 0.5s;
    -o-transition: all 0.5s;
    transition: all 0.5s;
  }
   .overlay h2{
    margin-top: 40%;
    color:#FFF;
    padding-left:20%;
    padding-right:20%;
    transform: scale(0);
    transition: all .5s;
    box-shadow: none!important;
  }
  .overlay .v-btn__content{
    transform: scale(0);
    transition: all 0.8s;
    opacity:1;
  } 
  .overlay_container:hover .overlay h2{
    transform: scale(1);
    opacity:1;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.39);
  }
  .overlay .v-btn{
    overflow:hidden;
  }
  .overlay_container:hover .v-btn__content{
  transform: scale(1);
  opacity:1;
  }
  .overlay_container:hover .overlay{
    opacity:1;
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.5), 0 6px 20px 0 rgba(0, 0, 0, 0.39);
  }
  .overlay_container:hover .v-card__title{
    opacity:0;
  } 
  .details{
    position:absolute;
    bottom:0;
    left:0;
    text-align:center;
    width:100%;
    margin:0;
    padding: 0;
  }
  .details .v-btn{
    width:100%;
  }
</style>
   


// WEBPACK FOOTER //
// src/components/shop/products/CampProducts.vue